module.exports = __webpack_public_path__ + "img/box.88a524ce.png";